// ✅ DO NOT import Amplify or configure here
// (it causes double initialization if imported before main.js)

const awsconfig = {
  Auth: {
    Cognito: {
      region: "eu-central-1",
      userPoolId: "eu-central-1_K2EsLBXIF",
      userPoolClientId: "3scgcuv4irfc35a3h6dekd4ov4",
      identityPoolId: "eu-central-1:775ba88d-ecf7-47db-af53-2dfeb660f4b0",

      // ✅ required in Amplify v6 for email login
      loginWith: {
        username: false,
        email: true,
        phone: false,
      },

      // ✅ oauth belongs INSIDE Cognito
      oauth: {
        domain: "nyb-portal-prod.auth.eu-central-1.amazoncognito.com",
        redirectSignIn: "https://kh.portal.bankszamlakivonat.hu/",
        redirectSignOut: "https://kh.portal.bankszamlakivonat.hu/",
        responseType: "code",
      },

      // ✅ cookieStorage belongs INSIDE Cognito
      cookieStorage: {
        domain: "bankszamlakivonat.hu",
        secure: false,
      },
    },
  },

  API: {
    endpoints: [
      {
        name: "RestApi",
        endpoint: "https://rest.bankszamlakivonat.hu",
        custom_header: async () => ({ Authorization: "token" }),
      },
      {
        name: "SocketApi",
        endpoint: "wss://socket.bankszamlakivonat.hu",
      },
    ],
  },
};

export default awsconfig;
